import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextH3Props {
    children: ReactNode
    className?: string
}

const TextH3 = ({ children, className }: TextH3Props) => {
    return <h3 className={[css.h3, className].filter(Boolean).join(' ')}>{children}</h3>
}

export default TextH3
